<template>
  <div class="ChannelItem d-flex align-items-center" :title="channel.value">
    <ChannelIcon
      :type="channel.type"
      :class="validationStatusColor"
      class="mr-2"
    />
    <span class="text-mono text-truncate">{{ channel.value }}</span>
  </div>
</template>

<script>
import ChannelIcon from "./ChannelIcon.vue";
import { checkValidation } from "../check-validation";

export default {
  name: "ChannelItem",
  props: ["channel"],
  components: { ChannelIcon },
  methods: {
    checkValidation,
  },
  computed: {
    validationStatusColor() {
      return checkValidation(this.channel)[0] ? 'text-success' : 'text-danger'
    },
  },
};
</script>

<style lang="scss" scoped>
.ChannelItem {
  white-space: nowrap;
}
</style>
